import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const BlankState = () => (
  <Box paddingTop="s120" paddingBottom="s120" gap="s16" alignItems="center">
    <Icon.Large icon="surveys" />
    <Text.Header2>{i18n.t('enps.results.errors.not_enough_answers.title')}</Text.Header2>
    <Text.Normal>{i18n.t('enps.results.errors.not_enough_answers.description')}</Text.Normal>
  </Box>
)

export default BlankState
